const responseValidationEmail = {
    "payload": {
        "userId": 130,
        "state": true,
        "tokentime": 5,
        "message": 'Se ha enviado un codigo de confirmación al correo ingresado'
    }
};

const responseValidationToken = {
    "payload": {
        "userId": 130,
        "validToken": true,
        "message": 'Código válido'
    }
};

export const service = {
    getValidationEmail: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseValidationEmail }), 1000);
    }),

    postValidateToken: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseValidationToken }), 1000);
    }),

    getResendToken: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseValidationEmail }), 1000);
    }),
}